import { render, staticRenderFns } from "./dr-navigation.vue?vue&type=template&id=17c36420"
import script from "./dr-navigation.vue?vue&type=script&lang=js"
export * from "./dr-navigation.vue?vue&type=script&lang=js"
import style0 from "./dr-navigation.vue?vue&type=style&index=0&id=17c36420&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports